import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

export default function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { user, loading, onboardingComplete } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader2 className="h-8 w-8 text-cyan-600 animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user account is locked, show locked overlay instead of redirecting
  // The GlobalLockStatusChecker and LockedAccountOverlay will handle displaying the lock UI
  // We still render the content but it will be blocked by the overlay

  // If user is not onboarded yet, redirect to welcome page
  if (!onboardingComplete) {
    return <Navigate to="/welcome" replace />;
  }

  return <>{children}</>;
}
